
// TODO: keep your URLs defined centrally here
export const LINKS = {
    CertifID: {
        PrivacyPolicy: 'https://www.certifid.com/company/privacy-policy',
        TermsOfUse: 'https://www.certifid.com/company/terms-of-service',
        VerifyIdentityMoreInfo: 'https://certifidhelpcenter.zendesk.com/hc/en-us/articles/18426417319579-I-don-t-feel-comfortable-providing-my-personal-information'
    },
    Docusign: {
        TermsOfUse: 'https://www.docusign.com/legal/terms-and-conditions',
    },
};